export const lang = {
  noComment: '亲,コメントなし~',
  noMoreData: '--もっとデータがありません--',
  loadPic: '写真を読み込んでいます',
  writeComment: 'コメントを書く...',
  writeComment2: 'コメントを書く',
  writeComment3: 'コメント',
  noCommentSelf: '自分のコメントに評論できません',
  nullComment: 'コメントなし',
  checkTips: 'コメントが提出しました、承認を貰ってから表示できます~',
  commentSuccess: 'コメントを提出成功',
  vname: '仮名のユーザー',
  maxPic: '一回に多くても',
  pic: '枚写真をアップロードできます',
  loading: '読み込んでいます...',
  loadingText: '読み込んでいます',
  upLoading: '読み込んでいます...',
  pullRefresh: '下にスライスと読み込む',
  letGoRefresh: '離すと読み込む',
  yesterday: '昨日',
  one: '月曜日',
  two: '火曜日',
  three: '水曜日',
  four: '木曜日',
  five: '金曜日',
  six: '土曜日',
  seven: '日曜日',
  delText: '削除',
  delTip: '削除成功',
  yes: '確認する',
  no: '取り消す',
  confirmTip: '削除を確認?',
  successTip: '成功する',
  failTip: '失敗', // 11111111
  unread: '未読',
  read: '既読',
  liked: '「いいね」にしました',
  commented: 'コメントを追加した文書',
  end: 'もっとがない',
  noData: 'もっとがない',
  cancel: 'キャンセル',
  refresh: '下にスライスと読み込む',
  // detail
  comment: 'コメント',
  name: '実名',
  send: '発表',
  thirdPlaceholder: '仮名に発表、ニックネームを設定できます',
  takePhoto: '撮影',
  fromPhotos: 'アルバムから選択',
  // rank
  recentRankTitle: '最近のランキング',
  lookAllRank: '歴史ランキング',
  allRankTitle: '歴史ランキング',
  error: 'アクセスエラー~',
  useMidea: '美信でアクセスしてください~',
  showHidingFloor: '表示',
  all: '全部',
  hide: '非表示',
  // article
  articleByTag: 'ラベル分類記事',
  seeAll: 'すべての',
  replies: 'つの返信を表示します',
  attachmentTip: 'コンピュータダウンロード',
  loadingArticleFail: 'サービス異常、しばらくしてから再試行するか、IT5000に連絡してください',
  loadArticleFail: 'サービス異常、しばらくしてから再試行するか、IT5000に連絡してください',
  notExist: '存在しない',
  writeAComment: 'コメントを書く',
  canNotSendEmptyComment: '空のコメントを送信できません',
  notFound: '見出されない...',
  articleDeleted: 'その記事は削除された',
  notEnoughParam: '十分でない',
  contentAddressNotFound: 'サービス異常、しばらくしてから再試行するか、IT5000に連絡してください',
  // content/detail
  contentWriteAComment: 'コメントを書く',
  contentComment: 'コメント',
  contentCommentDeleted: 'コメントは削除されました',
  contentNoMoreComment: 'これ以上のコメントはありません',
  contentSend: 'リリース',
  contentAnonymous: '匿名',
  contentNamed: '実名',
  contentCommentAuditing: '成功します。審査中です',
  contentCommentSuccess: '成功',
  contentReaded: '読みます',
  onlyMeixinCanOpen: 'この内容は美信でしか開けないよ',
  open: '美信が開く',
  contentFavoriteFail: 'フォローアップに失敗しました。後でやり直すか、IT5000に連絡してください。',
  contentCancelFavoriteFail: 'フォロー解除に失敗しました。後でやり直すか、IT5000に連絡してください。',
}
